import { ApiClientError, apiClient } from '../../core/api/client';
import type { IntimacyContext } from '../../core/providers/types';
import { getMomentAccountId } from '../moments/accountScope';
import { getMomentInteractionContext } from '../moments/interactionRepo';

export interface IntimacyState { presetId: string; characterId?: string; enabled: boolean; }

/** The server owns the switch and retention. Never cache affection or binding IDs locally. */
export async function requestIntimacy(presetId: string, enabled?: boolean, signal?: AbortSignal): Promise<IntimacyState> {
  const accountId = getMomentAccountId();
  if (!accountId) throw new ApiClientError('请先登录后设置亲密系统', 401);
  const state = await apiClient.request<IntimacyState>(`/v1/intimacy/${encodeURIComponent(presetId)}`, {
    method: enabled === undefined ? 'GET' : 'PUT',
    headers: { 'x-intimacy-account': accountId }, signal,
    ...(enabled === undefined ? {} : { body: { enabled } }),
  });
  if (getMomentAccountId() !== accountId) throw new Error('账号已切换，请重新设置亲密系统');
  return { presetId: state.presetId, enabled: state.enabled };
}

/** Social reactions are used only in this request, never copied to a cloud snapshot. */
export async function buildIntimacyContext(presetId: string, signal?: AbortSignal): Promise<IntimacyContext | undefined> {
  const accountId = getMomentAccountId();
  if (!accountId) return undefined;
  try {
    const state = await requestIntimacy(presetId, undefined, signal);
    if (!state.enabled) return undefined;
    const interactions = await getMomentInteractionContext(presetId);
    if (signal?.aborted || getMomentAccountId() !== accountId) return undefined;
    return { presetId, expectedAccountId: accountId, ...(interactions.length ? { interactions } : {}) };
  } catch (error) {
    if (signal?.aborted) throw error;
    // An unavailable optional system must not prevent ordinary chat.
    return undefined;
  }
}
